import DCSTable from "./Table/index";
import { DCSProvider, useDCS, DCSContext } from "./Table/DCSContext";
import { Stack, Typography, Select, MenuItem } from "@mui/material";
import StyleIcon from "@mui/icons-material/Style";
import React, { useContext, useEffect, useState } from "react";

export const Types = [
  "MRQ",
  "RFI",
  "Client",
  "Engineering",
  "Project Management",
  "Quality Control",
  "Fabrication",
  "Vendor",
];

function DocReviewerWithScope({
  projectId,
  plant,
  selectedOption,
  onTypeChange,
  hideTypeSelector,
}) {
  const { setDocumentTypeScope } = useDCS();

  useEffect(() => {
    setDocumentTypeScope(selectedOption);
    return () => setDocumentTypeScope(null);
  }, [selectedOption, setDocumentTypeScope]);

  return (
    <DocReviewerContent
      projectId={projectId}
      plant={plant}
      selectedOption={selectedOption}
      onTypeChange={onTypeChange}
      hideTypeSelector={hideTypeSelector}
    />
  );
}

export default function DocReviewer({
  projectId,
  plant = false,
  initialType = "Engineering",
  hideTypeSelector = false,
}) {
  const [selectedOption, setSelectedOption] = useState(initialType);
  const parentDcs = useContext(DCSContext);
  const hasParentProvider = parentDcs != null;

  if (hasParentProvider) {
    return (
      <DocReviewerWithScope
        projectId={projectId}
        plant={plant}
        selectedOption={selectedOption}
        onTypeChange={setSelectedOption}
        hideTypeSelector={hideTypeSelector}
      />
    );
  }

  return (
    <DCSProvider type={selectedOption} plant={plant}>
      <DocReviewerContent
        projectId={projectId}
        plant={plant}
        selectedOption={selectedOption}
        onTypeChange={setSelectedOption}
        hideTypeSelector={hideTypeSelector}
      />
    </DCSProvider>
  );
}

const DocReviewerContent = ({
  projectId,
  plant,
  selectedOption,
  onTypeChange,
  hideTypeSelector = false,
}) => {
  return (
    <>
      {!hideTypeSelector && (
        <Stack spacing={2} paddingBottom={2}>
          <Stack
            direction={"row"}
            spacing={2}
            sx={{ alignItems: "center", flexWrap: "wrap" }}
          >
            <StyleIcon color="secondary" sx={{ fontSize: 18 }} />
            <Typography variant="body2" color="primary" fontWeight={500}>
              Document Type:
            </Typography>
            <Select
              value={selectedOption}
              onChange={(event) => onTypeChange(event.target.value)}
              displayEmpty
              inputProps={{ "aria-label": "Select View" }}
              sx={{
                width: 150,
                backgroundColor: "background.paper",
                height: 32,
                fontSize: "0.8125rem",
                "& .MuiSelect-select": {
                  py: 0.75,
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: { "& .MuiMenuItem-root": { fontSize: "0.8125rem" } },
                },
              }}
            >
              {Types.map((option, index) => (
                <MenuItem key={index} value={option} sx={{ fontSize: "0.8125rem" }}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </Stack>
      )}
      <DCSTable
        projectId={projectId || ""}
        type={selectedOption}
        plant={plant}
        projectFilter="all"
      />
    </>
  );
};
